module.exports = __webpack_public_path__ + "static/fonts/Roboto-Regular.29503e9.eot";


//////////////////
// WEBPACK FOOTER
// ./autocomplete-component/dist/src/fonts/Roboto-Regular.eot
// module id = dd2y
// module chunks = 1